import type { AuthPermissionUser } from '../../services/authPermissions';

const PRODUCT_NAVIGATION_ROLES = ['ADMIN', 'OPERATIONS'];
const USER_MANAGEMENT_NAVIGATION_ROLES = ['ADMIN'];

export function canViewProductNavigation(user: AuthPermissionUser | null | undefined): boolean {
  return PRODUCT_NAVIGATION_ROLES.includes(user?.role || '');
}

export function canViewUserManagementNavigation(user: AuthPermissionUser | null | undefined): boolean {
  return USER_MANAGEMENT_NAVIGATION_ROLES.includes(user?.role || '');
}
